import { Auth, API } from 'aws-amplify';

const requestHeaders = async () => {
  return {
    'Content-Type': 'application/json',
    Authorization: `${(await Auth.currentSession())
      .getAccessToken()
      .getJwtToken()}`
  };
};

/* eslint-disable-next-line */
const listGroupsForUser = async function({ dispatch, getters, commit }, payload) {
  let path = '/listGroupsForUser';
  let username = payload.username;
  let limit = payload.limit;
  let token = payload.token;
  try {
    let payload = {
      queryStringParameters: {
        username,
        limit,
        token
      },
      headers: await requestHeaders()
    };
    let req = await API.get('AdminQueries', path, payload);
    if (req && req.Groups) {
      return req;
    }
    throw Error('Error listing groups for user.');
  } catch (error) {
    throw Error(error);
  }
};

export default listGroupsForUser;
